import { ChartAxis } from './ChartAxis';

export function BarChart({
  values,
  height = 180,
  color = '#3B82F6',
  selectedIndexes = [],
  onSelect,
}: {
  values: number[];
  height?: number;
  color?: string;
  // Which buckets are pinned via clicks - each rendered with a ring so the
  // detail panel's numbers can be traced back to the exact bars.
  selectedIndexes?: number[];
  onSelect?: (index: number) => void;
}) {
  const max = Math.max(...values.filter(Number.isFinite), 1);
  return (
    <ChartAxis max={max} height={height}>
      <div className="flex items-end gap-2.5 w-full h-full">
        {values?.map((value, i) => (
          <button
            key={i}
            type="button"
            disabled={!onSelect}
            onClick={() => onSelect?.(i)}
            className={`flex-1 rounded-t-lg ${onSelect ? 'cursor-pointer' : ''} ${
              selectedIndexes.includes(i) ? 'ring-2 ring-offset-1 ring-black/60 dark:ring-white/70' : ''
            }`}
            style={{ height: Number.isFinite(value) ? `${Math.max(8, (value / max) * 100)}%` : '0%', background: color }}
          />
        ))}
      </div>
    </ChartAxis>
  );
}
